// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Field details strip — Farm View "Field details" tab
   ---------------------------------------------------- */
.field-details-strip {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  flex: none;
  background: var(--color-grey-100);
  background: var(--color-grey-100);
  border: 1px solid var(--color-grey-91);
  border: 1px solid var(--color-grey-91);
  border-radius: 16px;
  overflow: hidden;
}

.field-details-strip__scroller {
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
}

.field-details-strip__scroller::-webkit-scrollbar {
  display: none;
}

.field-details-strip__track {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: -moz-max-content;
  width: max-content;
  min-width: 100%;
  padding: 16px 0 16px 24px;
  box-sizing: border-box;
}

.field-details-strip__track > * {
  flex: none;
}

/* Metric cell: label above value, divider on the right */
.field-details-metric--stacked {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  box-sizing: border-box;
  min-height: 36px;
  padding: 0 24px;
  border-right: 1px solid var(--color-grey-91);
  border-right: 1px solid var(--color-grey-91);
  white-space: nowrap;
  font-family: 'Source Sans Pro', sans-serif;
}

.field-details-metric--stacked:last-child {
  border-right: none;
}

.field-details-metric__label {
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: var(--color-grey-45);
  color: var(--color-grey-45);
}

.field-details-metric__value {
  font-weight: 700;
  font-size: 16px;
  line-height: 16px;
  color: var(--color-data-data);
  color: var(--color-data-data);
}

.field-details-metric--archive .field-details-metric__value {
  color: var(--color-grey-71);
  color: var(--color-grey-71);
}

.field-details-metric__last-seen {
  font-weight: 400;
  font-size: 12px;
  color: var(--color-data-data);
  color: var(--color-data-data);
}

/* Overlay arrows with a white fade over the strip edges (Figma "arrows wrap":
   40px wide, full height, 24x74 icon button) */
.field-details-strip__arrow {
  position: absolute;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  width: 40px;
  box-sizing: border-box;
  margin: 0;
  border: none;
  cursor: pointer;
  z-index: 2;
}

.field-details-strip__arrow-button {
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  box-sizing: border-box;
  width: 24px;
  padding: 8px;
  border-radius: 3px;
}

.field-details-strip__arrow--prev {
  left: 0;
  justify-content: flex-end;
  padding: 0 16px 0 0;
  background: linear-gradient(
    270deg,
    transparent 0%,
    var(--color-grey-100) 33.33%
  );
  background: linear-gradient(
    270deg,
    transparent 0%,
    var(--color-grey-100) 33.33%
  );
}

.field-details-strip__arrow--next {
  right: 0;
  justify-content: flex-start;
  padding: 0 0 0 16px;
  background: linear-gradient(
    90deg,
    transparent 4.17%,
    var(--color-grey-100) 33.33%
  );
  background: linear-gradient(
    90deg,
    transparent 4.17%,
    var(--color-grey-100) 33.33%
  );
}

.field-details-strip__arrow {
  color: var(--color-grey-45);
  color: var(--color-grey-45);
}

.field-details-strip__arrow:hover {
  color: var(--color-primary-idel);
  color: var(--color-primary-idel);
}

/* Crop water availability gauge cell (Figma "gauge cell": 255x40,
   padding 0 24, gap 8; text column 131 wide; gauge 68x36) */
.gauge-cell-farm {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  box-sizing: border-box;
  width: 255px;
  height: 40px;
  padding: 0 24px;
  border-right: 1px solid var(--color-grey-91);
  border-right: 1px solid var(--color-grey-91);
  font-family: 'Source Sans Pro', sans-serif;
}

.gauge-cell-farm__text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: none;
  width: 131px;
  height: 32px;
}

.gauge-cell-farm__label {
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: var(--color-grey-45);
  color: var(--color-grey-45);
  white-space: nowrap;
  /* Longer translations (pt/es) are trimmed to the 131px column; the full
     text is on the title tooltip. */
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.gauge-cell-farm__wrap {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  height: 16px;
  white-space: nowrap;
}

.gauge-cell-farm__status {
  font-weight: 700;
  font-size: 16px;
  line-height: 16px;
}

.gauge-cell-farm__synced {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: var(--color-grey-71);
  color: var(--color-grey-71);
}

.gauge-cell-farm__synced img {
  width: 14px;
  height: 14px;
}

/* IrrigationMeter renders an inline-styled 80x80 box whose canvas is 100%
   wide at a 2:1 ratio; size that box to the Figma gauge (68x36). */
.gauge-cell-farm__gauge {
  flex: none;
  width: 68px;
  height: 36px;
}

.gauge-cell-farm__gauge > div {
  width: 68px !important;
  height: 36px !important;
}
`, "",{"version":3,"sources":["webpack://./app/components/dashboard/AllFarmView/FieldDetailsStrip.css"],"names":[],"mappings":"AAAA;yDACyD;AACzD;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,UAAU;EACV,iCAAiC;EACjC,iCAAiC;EACjC,sCAAsC;EACtC,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,4CAA4C;EAC5C,4CAA4C;EAC5C,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;+CAC+C;AAC/C;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,yBAAyB;EACzB,mBAAmB;EACnB;;;;GAIC;EACD;;;;GAIC;AACH;;AAEA;EACE,QAAQ;EACR,2BAA2B;EAC3B,mBAAmB;EACnB;;;;GAIC;EACD;;;;GAIC;AACH;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;4DAC4D;AAC5D;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,4CAA4C;EAC5C,4CAA4C;EAC5C,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,UAAU;EACV,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,2BAA2B;EAC3B,mBAAmB;EACnB;oCACkC;EAClC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;mEACmE;AACnE;EACE,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB","sourcesContent":["/* Field details strip — Farm View \"Field details\" tab\n   ---------------------------------------------------- */\n.field-details-strip {\n  position: relative;\n  box-sizing: border-box;\n  width: 100%;\n  flex: none;\n  background: var(--color-grey-100);\n  background: var(--color-grey-100);\n  border: 1px solid var(--color-grey-91);\n  border: 1px solid var(--color-grey-91);\n  border-radius: 16px;\n  overflow: hidden;\n}\n\n.field-details-strip__scroller {\n  overflow-x: auto;\n  overflow-y: hidden;\n  scrollbar-width: none;\n}\n\n.field-details-strip__scroller::-webkit-scrollbar {\n  display: none;\n}\n\n.field-details-strip__track {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: -moz-max-content;\n  width: max-content;\n  min-width: 100%;\n  padding: 16px 0 16px 24px;\n  box-sizing: border-box;\n}\n\n.field-details-strip__track > * {\n  flex: none;\n}\n\n/* Metric cell: label above value, divider on the right */\n.field-details-metric--stacked {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  box-sizing: border-box;\n  min-height: 36px;\n  padding: 0 24px;\n  border-right: 1px solid var(--color-grey-91);\n  border-right: 1px solid var(--color-grey-91);\n  white-space: nowrap;\n  font-family: 'Source Sans Pro', sans-serif;\n}\n\n.field-details-metric--stacked:last-child {\n  border-right: none;\n}\n\n.field-details-metric__label {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 16px;\n  color: var(--color-grey-45);\n  color: var(--color-grey-45);\n}\n\n.field-details-metric__value {\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 16px;\n  color: var(--color-data-data);\n  color: var(--color-data-data);\n}\n\n.field-details-metric--archive .field-details-metric__value {\n  color: var(--color-grey-71);\n  color: var(--color-grey-71);\n}\n\n.field-details-metric__last-seen {\n  font-weight: 400;\n  font-size: 12px;\n  color: var(--color-data-data);\n  color: var(--color-data-data);\n}\n\n/* Overlay arrows with a white fade over the strip edges (Figma \"arrows wrap\":\n   40px wide, full height, 24x74 icon button) */\n.field-details-strip__arrow {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  width: 40px;\n  box-sizing: border-box;\n  margin: 0;\n  border: none;\n  cursor: pointer;\n  z-index: 2;\n}\n\n.field-details-strip__arrow-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  align-self: stretch;\n  box-sizing: border-box;\n  width: 24px;\n  padding: 8px;\n  border-radius: 3px;\n}\n\n.field-details-strip__arrow--prev {\n  left: 0;\n  justify-content: flex-end;\n  padding: 0 16px 0 0;\n  background: linear-gradient(\n    270deg,\n    transparent 0%,\n    var(--color-grey-100) 33.33%\n  );\n  background: linear-gradient(\n    270deg,\n    transparent 0%,\n    var(--color-grey-100) 33.33%\n  );\n}\n\n.field-details-strip__arrow--next {\n  right: 0;\n  justify-content: flex-start;\n  padding: 0 0 0 16px;\n  background: linear-gradient(\n    90deg,\n    transparent 4.17%,\n    var(--color-grey-100) 33.33%\n  );\n  background: linear-gradient(\n    90deg,\n    transparent 4.17%,\n    var(--color-grey-100) 33.33%\n  );\n}\n\n.field-details-strip__arrow {\n  color: var(--color-grey-45);\n  color: var(--color-grey-45);\n}\n\n.field-details-strip__arrow:hover {\n  color: var(--color-primary-idel);\n  color: var(--color-primary-idel);\n}\n\n/* Crop water availability gauge cell (Figma \"gauge cell\": 255x40,\n   padding 0 24, gap 8; text column 131 wide; gauge 68x36) */\n.gauge-cell-farm {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  box-sizing: border-box;\n  width: 255px;\n  height: 40px;\n  padding: 0 24px;\n  border-right: 1px solid var(--color-grey-91);\n  border-right: 1px solid var(--color-grey-91);\n  font-family: 'Source Sans Pro', sans-serif;\n}\n\n.gauge-cell-farm__text {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  flex: none;\n  width: 131px;\n  height: 32px;\n}\n\n.gauge-cell-farm__label {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 16px;\n  color: var(--color-grey-45);\n  color: var(--color-grey-45);\n  white-space: nowrap;\n  /* Longer translations (pt/es) are trimmed to the 131px column; the full\n     text is on the title tooltip. */\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.gauge-cell-farm__wrap {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  height: 16px;\n  white-space: nowrap;\n}\n\n.gauge-cell-farm__status {\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 16px;\n}\n\n.gauge-cell-farm__synced {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 16px;\n  color: var(--color-grey-71);\n  color: var(--color-grey-71);\n}\n\n.gauge-cell-farm__synced img {\n  width: 14px;\n  height: 14px;\n}\n\n/* IrrigationMeter renders an inline-styled 80x80 box whose canvas is 100%\n   wide at a 2:1 ratio; size that box to the Figma gauge (68x36). */\n.gauge-cell-farm__gauge {\n  flex: none;\n  width: 68px;\n  height: 36px;\n}\n\n.gauge-cell-farm__gauge > div {\n  width: 68px !important;\n  height: 36px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
